/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteVideoEditorEditsEditMutationResponse, WebAppDeleteVideoEditorEditsEditPathParams } from "../models/WebAppDeleteVideoEditorEditsEdit";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppDeleteVideoEditorEditsEdit } from "../axios/webAppDeleteVideoEditorEditsEdit";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppDeleteVideoEditorEditsEditMutationKey = () => [{ url: '/web-app/v1/video-editor/edits/:id' }] as const

export type WebAppDeleteVideoEditorEditsEditMutationKey = ReturnType<typeof webAppDeleteVideoEditorEditsEditMutationKey>

export function webAppDeleteVideoEditorEditsEditMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = webAppDeleteVideoEditorEditsEditMutationKey()
        return mutationOptions<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: WebAppDeleteVideoEditorEditsEditPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return webAppDeleteVideoEditorEditsEdit(id, config)
          },
        })

}

/**
 * @summary Delete an edit
 * {@link /web-app/v1/video-editor/edits/:id}
 */
export function useWebAppDeleteVideoEditorEditsEdit<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: WebAppDeleteVideoEditorEditsEditPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppDeleteVideoEditorEditsEditMutationKey()

          const baseOptions = webAppDeleteVideoEditorEditsEditMutationOptions(config) as UseMutationOptions<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: WebAppDeleteVideoEditorEditsEditPathParams["id"]}, TContext>
          

          return useMutation<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: WebAppDeleteVideoEditorEditsEditPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: WebAppDeleteVideoEditorEditsEditPathParams["id"]}, TContext>
      
}